<template>
    <div class="instructor-chat">
        <v-btn-toggle v-model="toggle_exclusive" tile group style="color: #2F80ED">
            <v-btn dense outlined v-for="item in childrenData" :key="item.id"
                   style="padding: 30px 10px; border-radius: 8px; color: black"
                   @click="getScheduleByChildren(item, 'teacher')">
                <div style="display: flex; flex-direction: column">
                    <div>{{item.studentName}} {{item.studentSurname}}</div>
                </div>
            </v-btn>
        </v-btn-toggle>
        <ParentChatComponent ref="chat"/>
    </div>
</template>

<script>
import ParentChatComponent from "@/views/parents/ParentChatComponent.vue";
import ParentService from '@/_services/parent.service'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
export default {
  name: 'StudentChat',
  components: {
      ParentChatComponent
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },
  data () {
    return {
        toggle_exclusive: null,
        childrenData: []
    }
  },
  mounted () {
      this.getChildren()
  },
  methods: {
      getScheduleByChildren (item) {
          this.$refs.chat.selectedTab = 'teacher'
          this.$refs.chat.schoolId = item.schoolId
          this.$refs.chat.classId = item.studentClassId
          this.$refs.chat.fetchUsers('teacher')
      },
      getChildren () {
          ParentService.getAllChildren(this.userProfile.personId).then((res) => {
              this.isLoading = false
              if (res._embedded) {
                  this.childrenData = res._embedded.studentParentResourceList
              } else {
                  this.childrenData = []
              }
          }).catch((err) => {
              this.$toast.error(err)
              this.isLoading = false
          })
      }
  }
}
</script>

<style scoped>

</style>
